// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(colorOpt, param) {
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.red400;
  return {
          color: color
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
